export default window._cmsContent['solar/electricity-unit-rate']